import {UPDATE_DATE} from '../actionTypes';

const initialState = '';

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_DATE:
      return action.payload;

    default:
      return state;
  }
}
